import { useTranslation } from 'react-i18next'

import Github from 'images/github.svg'
import LinkedIn from 'images/linkedin.svg'
import linkImage from 'images/Link.svg'
import ProjectItem from 'components/Projects/ProjectItem'
import ExperienceItem from 'components/Experiences/ExperienceItem'

import NavBar from 'components/NavBar/NavBar'
import Footer from 'components/Footer/Footer'

import CV from 'files/Cyrielle CHASLES - CV.pdf'
import Resume from 'files/Cyrielle CHASLES - Resume.pdf'

function App() {
  const { i18n, t } = useTranslation()
  const projects = [
    {
      name: t(`HomePage.projects.jarvis.name`),
      description: t(`HomePage.projects.jarvis.description`),
      tags: ['Claude Code', 'Next.js', 'Typescript', 'Tailwind', 'Vitest', 'MongoDB'],
      link: 'https://jarvishouse.app/',
      github: undefined,
    },
    {
      name: t(`HomePage.projects.airpeger.name`),
      description: t(`HomePage.projects.airpeger.description`),
      tags: ['React', 'Node.js', 'Tailwind', 'Jest', 'MongoDB'],
      link: 'https://airpeger.fr/',
      github: undefined,
    },
    {
      name: t(`HomePage.projects.amigurumoi.name`),
      description: t(`HomePage.projects.amigurumoi.description`),
      tags: ['Next.js', 'Typescript', 'Tailwind', 'MongoDB', 'Vitest'],
      link: 'https://www.amigurumoi.com/',
      github: undefined,
    },
    {
      name: t(`HomePage.projects.kanap.name`),
      description: t(`HomePage.projects.kanap.description`),
      tags: ['Javascript', 'Git', 'localStorage'],
      link: undefined,
      github: undefined,
    },
    {
      name: t(`HomePage.projects.kasa.name`),
      description: t(`HomePage.projects.kasa.description`),
      tags: ['React', 'Github pages'],
      link: 'https://krauzeure.github.io/dwP7',
      github: 'https://github.com/krauzeure/dwP7',
    },
  ]

  const experiences = [
    {
      name: t(`HomePage.experiences.ato.name`),
      title: t(`HomePage.experiences.ato.title`),
      description: t(`HomePage.experiences.ato.description`),
      tags: ['React', 'Typescript', 'NodeJS', 'Jest', 'Playwright'],
      periodStart: '2023-07-01',
      periodEnd: '2025-12-31',
    },
    {
      name: t(`HomePage.experiences.openclassrooms.name`),
      title: t(`HomePage.experiences.openclassrooms.title`),
      description: t(`HomePage.experiences.openclassrooms.description`),
      periodStart: '2019-07-01',
      periodEnd: '2023-06-30',
      tags: ['Javascript', 'Integration'],
    },
    {
      name: t(`HomePage.experiences.drivy.name`),
      title: t(`HomePage.experiences.drivy.title`),
      description: t(`HomePage.experiences.drivy.description`),
      periodStart: '2018-01-01',
      periodEnd: '2019-06-30',
    },
    {
      name: t(`HomePage.experiences.leboncoin.name`),
      title: t(`HomePage.experiences.leboncoin.title`),
      description: t(`HomePage.experiences.leboncoin.description`),
      periodStart: '2012-10-01',
      periodEnd: '2017-12-31',
    },
  ]
  return (
    <div className='p-8'>
      <NavBar />
      <main className='lg:flex mt-8 p-3 relative w-full'>
        <div className='lg:mr-24 info lg:sticky top-44 h-fit mb-8 dev-info'>
          <h1>Cyrielle Chasles</h1>
          <h2>{t('HomePage.title')}</h2>
          <p className='my-2 font-light'>{t('HomePage.subtitle')}</p>
          <div className='flex mt-4'>
            <div className='flex items-center'>
              <a href='https://github.com/krauzeure' target='_blank' rel='noreferrer'>
                <img src={Github} alt='github' className='social_media_logo image-link' />
              </a>
              <a href='https://www.linkedin.com/in/cyrielle-chasles/' target='_blank' rel='noreferrer'>
                <img src={LinkedIn} alt='github' className='social_media_logo image-link' />
              </a>
            </div>
            <div className='flex items-center rounded-full border border-neutral-300 dark:border-neutral-700 px-3.5 py-1.5 w-fit'>
              <div className='font-light text-sm mr-2'>{t('HomePage.unavailable')}</div>
              <span className='relative flex h-3 w-3'>
                <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-600 opacity-75'></span>
                <span className='relative inline-flex rounded-full h-3 w-3 bg-red-700'></span>
              </span>
            </div>
          </div>
        </div>
        <div className='lg:grow'>
          <div className='mb-18 lg:p-6 about-content' id='about'>
            <p>{t('HomePage.about.paragraph1')}</p>
            <p>{t('HomePage.about.paragraph2')}</p>
            <p>{t('HomePage.about.paragraph3')}</p>
          </div>
          <ul className='mb-8 experiences-content' id='experience'>
            {experiences.map((experience) => (
              <ExperienceItem experience={experience} key={experience.name} />
            ))}
          </ul>
          <div className='mb-24 lg:pl-6'>
            <a
              href={i18n.resolvedLanguage === 'fr' ? CV : Resume}
              target='_blank'
              rel='noopener noreferrer'
              className='flex items-center mb-3 mr-2 transition delay-100 duration-300 ease-in-out hover:-translate-y-1 cursor-pointer'
            >
              <p>{t('HomePage.download')}</p>
              <img src={linkImage} alt='Cyrielle Chasles CV' className='ml-2 image-link' />
            </a>
          </div>
          <ul className='mb-24 projects-content' id='projects'>
            {projects.map((project) => (
              <ProjectItem key={project.name} project={project} />
            ))}
          </ul>
          <div className='contact-content' id='contact'>
            <h3 className='text-lg font-semibold'>{t('HomePage.get-in-touch')}</h3>
            <p>
              {t('HomePage.contact-me')}
              <a href='https://www.linkedin.com/in/cyrielle-chasles/' target='_blank' rel='noreferrer'>
                LinkedIn
              </a>
              {t('HomePage.or-by')}
              <a href='mailto:cyrielle.chasles@gmail.com'>email</a>
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default App
